export interface IAddSaleItemRequest {
  categoryId: number;
  unitTypeId: number;
  title: string;
  quantity: number;
  totalPrice: number;
  branchId: number;
  customerPersonId: number;
  saleKey: string;
}
export interface ISaleItemResponse {
  saleItems: ISaleItem[];
  totalAmountOfSaleItems: number;
  totalAmountOfSaleItemsInAlphabet: string;
}
export interface ISaleItem {
  id: number;
  saleItemGroupTitle: string;
  title: string;
  quantity: string;
  unitPrice: number;
  saleItemTotalAmount: number;
}

export interface IGetSaleItemsRequest {
  customerPersonId: number;
  branchId: number;
}
export interface ISaleItemRequest {
  saleKey: string;
  branchId: number;
  customerPersonId: number;
  ibans?: string;
  ibanId?: number;
  from?: string;
}
export interface IDeleteSaleItemRequest {
  id: number;
  branchId: number;
  customerPersonId: number;
  saleKey: string;
}
export interface ICancelInvoiceRequest {
  branchId: number;
  customerPersonId: number;
  saleKey: string;
}
export interface IGetByKeyResponse {
  cashAmount: number;
  saleAmount: number;
  saleItems: ISaleItem[];
  saleStatusId: string;
  saleStatusTitle: string;
  saleDate: Date;
  issuanceInvoiceDate: Date;
  confirmInvoiceDate: Date;
  expirationDate: Date;
  saleDate_Persian: string;
  issuanceInvoiceDate_Persian: string;
  confirmInvoiceDate_Persian: string;
  expirationDate_Persian: string;
  settlementDate_Persian: string;
  saleAmountInAlphabet: string;
  creditAmount: number;
  branchTitle: string;
  branchAddress: string;
  customerFullName: string;
  customerMobileNumber: string;
  customerWalletAmount: number;
  totalSettlementAmount: number;
  invoiceFiles: IInvoiceFiles[];
  rejectReasons: string[];
  saleType: string;
  saleTypeTitle: string;
  storeUrl: string;
  factoreNumber: string;
  storeTitle: string;
  saleItemsFeeAmount: number;
  repaymentFeeAmount: number;
  supplierSideLoanFeeAmount: number;
  taxAmount: number;
}

export interface IInvoiceFiles {
  id: number;
  key: string;
  fileId: string;
  thumbnailFileId: string;
  fileName: string;
  documentType: string;
  documentTypeTitle: string;
  fileType: string;
  fileUrl: string;
  thumbnailFileUrl: string;
}

export interface IInvoiceResponse {
  successful: boolean;
  message: string;
}
export class IVerifyInvoiceDetailsByCustomerRequest {
  otp: string | undefined;
  saleKey: string | undefined;
  branchId: number | undefined;
  customerPersonId: number | undefined;
}
export interface IVerifyInvoiceDetailsByCustomerResponse {
  validationIssues: string[];
  isValid: boolean;
}
export interface IUploadInvoiceFileRequest {
  file: File;
  customerPersonId: number;
  branchId: number;
  saleKey: string;
}
export interface IDeleteInvoiceFileRequest {
  fileId: string;
  branchId: number;
  customerPersonId: number;
}
export interface IGetSaleItemGroupsResponse {
  id: number;
  title: string;
  unitType: unitType[];
}

export interface unitType {
  id: Number;
  unitType: string;
  unitTypeTitle: string;
}
export interface IGetSaleItemGroupsRequest {
  branchId: number;
}
export interface IWaitForConfirmRequestRequest {
  saleKey: string;
  branchId: number;
  customerPersonId: number;
  factorNumber: string;
}
